import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { CountryService } from '../Services/country.service';
import { CommonService } from '../Services/common.service';
import { SettingService } from '../Services/setting.service';
import { CookieService } from '../Services/cookie';
import { AuthService } from '../Services/auth.service';
// import { Subject } from "rxjs";

@Component({
  selector: "app-feedbacks",
  templateUrl: "./feedbacks.component.html",
  standalone:false,
  styleUrls: ["./feedbacks.component.scss"],
})
export class FeedbacksComponent implements OnInit {
  // modalObservable: Subject<void> = new Subject<void>();
  selectedNationality: string = "";
  Nationalitylist;
  name: string = "";
  email: string = "";
  number: string = "";
  IdNumber: string = "";
  Company: string = "";
  Msg: string = "";
  Reference: any;
  emailusShow: any;
  isNameValid: boolean = true;
  isEmailValid: boolean = true;
  isMobileNumberValid: boolean = true;
  isIdNumberValid: boolean = true;



  constructor(private router: Router, private location: Location, private country: CountryService,public auth: AuthService, private common: CommonService,private cookieService: CookieService,
    private set: SettingService, private route: Router) { }

  async ngOnInit(): Promise<any> {
    
    // 
        //       <left-panel activeTab="10" *ngIf="this.auth?.detailuser != undefined"></left-panel>
        // <app-left-panel-prelogin activeTab="3" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
  //   if (this.auth.detailuser) {
  //   this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
  //     if (data?.response?.code == 1) {
  //      this.common.hideLoading();



  //     }
  //     else {
  //       await this.common.hideLoading();
  //       this.common.ParseErrorAlert("", "", this.router, data);
  //     }

  //   });
  // }
    // 

    let a =await this.cookieService.get("emailusss", true);
    if (a) {
      this.emailusShow = JSON.parse(a);
    }
    console.log("datahere",this.emailusShow)
    this.country.Nationality(this.common.Guid()).then((res: any) => {

      if (res?.response.code == 1) {

        this.Nationalitylist = res.response.content.map(x => ({ iconClass: "", displayValue: x.countryNameEN }));

        console.log('NAtionalitydropdown', this.Nationalitylist)
      }
      else {
        this.common.ParseErrorAlert('', 'OK', this.route, res)
      }
    })


  }
// Validate email format
validateName(): void {
  const nameRegex = /^[A-Za-z\s]*$/; // Allows only letters and spaces
  this.isNameValid = nameRegex.test(this.name);
}

validateEmail(): void {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Standard email regex
  this.isEmailValid = emailRegex.test(this.email);
}


validateMobileNumber(): void {
  const mobileNumberRegex = /^[0-9]{1,8}$/; // Allows up to 8 digits only
  this.isMobileNumberValid = mobileNumberRegex.test(this.number);
}

validateIdNumber(): void {
  const idNumberRegex = /^[0-9]*$/; // Allows only digits
  this.isIdNumberValid = idNumberRegex.test(this.IdNumber);
}
  // Valid() {

  //   if (this.name != "" && this.email != "" && this.number != "" && this.IdNumber != "" && this.selectedNationality != "" && this.Company != "" && this.Msg != "") {

  //     return false;
  //   }
  //   else {
  //     return true;
  //   }


  // }

  Valid(): boolean {
    return (
      this.name === "" || !this.isNameValid ||
      this.email === "" || !this.isEmailValid ||
      this.number === "" || !this.isMobileNumberValid ||
      this.IdNumber === "" || !this.isIdNumberValid ||
      this.selectedNationality === "" ||
      this.Company === "" ||
      this.Msg === ""
    );
  }

  back() {
    this.location.back();
  }

  onNationalityChange(event) {
    this.selectedNationality = event.displayValue;
  }
  feedbackSuccess() {

    if (this.Valid()) {
      alert("Please fill all fields correctly.");
      return;
    }

    this.common.presentLoading();
    let obj = {
      "UniqueId": this.common.Guid(),
      "Name": this.name,
      "Email": this.email,
      "MobileNo": this.number,
      "IdNumber": this.IdNumber.toString(),
      "Nationality": this.selectedNationality,
      "Company": this.Company,
      "Message": this.Msg
    }

    this.set.SaveFeedBacksPreLogin(obj).then((res: any) => {
      if (res?.response?.code == 1) {
        this.common.hideLoading();
        this.Reference = res.response.content.referenceId;
        this.router.navigateByUrl("/FeedbackSuccess");
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', 'OK', this.route, res);
      }
    })
  }
}